import { CourseCrmShippingStatus, COURSE_CRM_STATUS_LABELS } from '@/models/course-crm';

/**
 * Status chips, built the way `dark-inline-styles` prescribes: a translucent
 * wash of the hue for the fill and the LIGHT hue for the label. The tempting
 * alternative — the saturated hue as a background with white text — measures
 * about 1.8:1 and is exactly what made the Schedules queue status unreadable.
 */
const CHIP: Record<CourseCrmShippingStatus, { fill: string; border: string; text: string }> = {
    not_started: { fill: 'rgba(255,255,255,0.06)', border: 'rgba(255,255,255,0.18)', text: '#bbbbbb' },
    awaiting_shipment: { fill: 'rgba(224,164,88,0.12)', border: 'rgba(224,164,88,0.35)', text: '#e0a458' },
    shipped: { fill: 'rgba(125,163,255,0.12)', border: 'rgba(125,163,255,0.35)', text: '#7da3ff' },
    delivered: { fill: 'rgba(109,219,160,0.12)', border: 'rgba(109,219,160,0.35)', text: '#6ddba0' },
    needs_attention: { fill: 'rgba(255,107,107,0.12)', border: 'rgba(255,107,107,0.35)', text: '#ff9b9b' },
};

const StatusChip = ({ status }: { status: CourseCrmShippingStatus }) => {
    const c = CHIP[status] ?? CHIP.not_started;
    return (
        <span
            style={{
                display: 'inline-block',
                padding: '3px 10px',
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 600,
                whiteSpace: 'nowrap',
                background: c.fill,
                border: `1px solid ${c.border}`,
                color: c.text,
            }}
        >
            {COURSE_CRM_STATUS_LABELS[status] ?? status}
        </span>
    );
};

export default StatusChip;

/** `Paid` / `Gift` pill. Same recipe, two hues. */
export const TypeChip = ({ type }: { type?: 'paid' | 'gift' }) => {
    if (!type) return <span style={{ color: '#777777' }}>—</span>;
    const c =
        type === 'paid'
            ? { fill: 'rgba(125,163,255,0.12)', border: 'rgba(125,163,255,0.35)', text: '#7da3ff' }
            : { fill: 'rgba(235,104,52,0.14)', border: 'rgba(235,104,52,0.35)', text: '#f08a5d' };
    return (
        <span
            style={{
                display: 'inline-block',
                padding: '2px 9px',
                borderRadius: 999,
                fontSize: 11.5,
                fontWeight: 600,
                textTransform: 'capitalize',
                background: c.fill,
                border: `1px solid ${c.border}`,
                color: c.text,
            }}
        >
            {type}
        </span>
    );
};
